import { render, staticRenderFns } from "./ToolHeader.vue?vue&type=template&id=06484de6&scoped=true&"
import script from "./ToolHeader.vue?vue&type=script&lang=ts&"
export * from "./ToolHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ToolHeader.vue?vue&type=style&index=0&id=06484de6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06484de6",
  null
  
)

export default component.exports